export default "__VITE_ASSET__DjUAQOPa__"